<template>
    <div class="audio-block">
        <h3>{{ file.name }}</h3> <br>       
        <v-layout row wrap>
            <v-flex xs12 sm4>
                    <div class="py-2">
                        <p>{{ file.author }}</p>           
                    </div>
            </v-flex>
            <v-flex xs12 sm8>
                <audio controls>
                    <source :src="`/audio/${file.url}`" type="audio/mpeg">
                        Your browser does not support the audio element.
                    </audio>  
            </v-flex>
        </v-layout>  
    </div>                                 
</template>

<script>
    export default {
        props: ['file']    
    }
</script>

<style>
    .audio-block {
         border: 1px Solid #333; 
         padding: 15px;
         margin-right: 5px;
     }
     .audio-block h3 {
         font-family: 'Open Sans Condensed', sans-serif;
     }
     .audio-block p {
         color: #C4B384;
     }
</style>
